import ImportJsonIcon from './ImportJsonIcon'

export default ImportJsonIcon
